
$(function () {
    $(".js-tagify").tagify({
        originalInputValueFormat: (valuesArr) => {
            return valuesArr.map(tag => tag.value).join(',');
        },
        duplicates: false,
        autocomplete: true,
        enforceWhitelist: true,
        userInput: false,
        dropdown: {
            maxItems: 10,
            closeOnSelect: false,
            classname: "tags-look",
            enabled: 0
        }
    });
});

$(function () {
    $('.js-tagify-json').each(function () {
        $(this)
            .tagify({
                duplicates: false,
                autocomplete: true,
                enforceWhitelist: true,
                whitelist: $(this).data("json"),
                userInput: false,
                dropdown: {
                    maxItems: 10,
                    closeOnSelect: false,
                    classname: "tags-look",
                    enabled: 0
                }
            });
    });
});

function transformer(value) {
    return value.replace(/\[\[(.*?)\]\]/g, (arr => {
        let json = JSON.parse(arr);
        return json[0].map(e => e.code).join(', ');
    }))
}

$(function () {
    $(".js-tagify-dynamic").tagify({
        originalInputValueFormat: (valuesArr) => {
            return valuesArr.map(tag => tag.value).join(',');
        },
        duplicates: false,
        autocomplete: true,
        enforceWhitelist: false,
        userInput: true,
        dropdown: {
            maxItems: 10,
            closeOnSelect: false,
            classname: "tags-look",
            enabled: 0
        }
    });
});

